
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"22","cy":"22","r":"16","fill":"#F2F3F5"}}),_c('path',{attrs:{"d":"M15 17.89h5.779M15 26.145h5.779","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M28.592 16.277l-.337.732h-4.67l.266-.732h4.741zm-.636 1.442l-.344.738h-4.027l.266-.738h4.105zm1.503-3.37l-.42.898a3.038 3.038 0 00-.433-.309 2.298 2.298 0 00-.504-.22 1.912 1.912 0 00-.579-.085c-.379 0-.716.102-1.012.305-.296.204-.53.51-.7.916-.168.405-.252.91-.252 1.513 0 .604.084 1.108.252 1.513.17.405.404.709.7.913.296.2.633.302 1.012.302.208 0 .403-.028.582-.082.183-.055.348-.126.498-.213.151-.09.287-.185.408-.284l.43.895a2.53 2.53 0 01-.874.514c-.331.116-.68.174-1.044.174a2.82 2.82 0 01-1.58-.45c-.457-.301-.816-.73-1.076-1.286-.26-.559-.39-1.224-.39-1.996 0-.774.13-1.44.39-2 .26-.558.619-.988 1.076-1.288.46-.3.986-.451 1.58-.451.379 0 .732.063 1.058.188.327.123.62.3.878.533zM28.592 25.675l-.337.732h-4.67l.266-.732h4.741zm-.636 1.442l-.344.738h-4.027l.266-.738h4.105zm1.503-3.37l-.42.898a3.045 3.045 0 00-.433-.309 2.288 2.288 0 00-.504-.22 1.912 1.912 0 00-.579-.085c-.379 0-.716.102-1.012.305-.296.204-.53.51-.7.916-.168.405-.252.91-.252 1.513 0 .604.084 1.108.252 1.513.17.405.404.709.7.913.296.2.633.301 1.012.301a2 2 0 00.582-.081c.183-.055.348-.126.498-.213.151-.09.287-.185.408-.284l.43.894c-.251.228-.542.4-.874.515-.331.116-.68.174-1.044.174a2.82 2.82 0 01-1.58-.45c-.457-.301-.816-.73-1.076-1.286-.26-.559-.39-1.224-.39-1.996 0-.774.13-1.44.39-2 .26-.558.619-.988 1.076-1.288.46-.3.986-.451 1.58-.451.379 0 .732.063 1.058.188.327.123.62.3.878.533z","fill":"#363636"}})])
          )
        }
      }
    